<template>
  <DatePicker
    v-bind="$props"
    :fromPage="fromPage"
    :toPage="toPage"
    :max-date="new Date()"
    @input="onChange"
  ></DatePicker>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import moment from "moment";

import { setupCalendar, DatePicker } from "v-calendar";
import "v-calendar/lib/v-calendar.min.css";

setupCalendar({
  firstDayOfWeek: 1,
  paneWidth: 285,
  locale: "en-US",
  titleTransition: "none",
  weeksTransition: "none",
  formats: {
    title: "MMMM YYYY",
    weekdays: "WW",
    navMonths: "MMM",
    input: ["L", "YYYY-MM-DD", "YYYY/MM/DD"],
    dayPopover: "WWW, MMM D, YYYY",
    data: ["L", "YYYY-MM-DD", "YYYY/MM/DD"]
  },
  datePickerTintColor: "#5757f5",
  datePickerShowDayPopover: false,
  datePickerShowCaps: false,
  popoverVisibility: "visible",
  popoverExpanded: true,
  themeStyles: {
    wrapper: {
      backgroundColor: "#FFFFFF",
      borderRadius: "5px",
      boxShadow: "3px 3px 25px rgba(0, 0, 0, 0.25)"
    },

    headerTitle: {
      fontSize: "14px",
      fontFamily: "'Lato-Regular', sans-serif"
    },

    navHeaderTitle: {
      fontSize: "12px",
      fontFamily: "'Lato-Regular', sans-serif"
    },

    headerArrows: {
      width: "12px",
      color: "#979797"
    },

    navHeaderArrows: {
      width: "12px",
      color: "#979797"
    },

    dayCellNotInMonth: {
      color: "#C4C4C4",
      border: "none"
    },

    dayCell: {
      fontSize: "12px",
      color: "#1F1F1F",
      border: "0.5px solid #E5E5E5",
      borderRadius: "3px",
      fontFamily: "'Lato-Regular', sans-serif",
      width: "38px",
      height: "38px",
      margin: "1px"
    },

    dayContent: {
      width: "38px",
      height: "38px",
      fontSize: "12px",
      margin: 0
    },

    dayContentHover: {
      width: "38px",
      height: "38px",
      margin: 10,
      backgroundColor: "transparent"
    }
  }
});

Vue.component("DatePicker", DatePicker);

export default Vue.component("VDatePicker", {
  props: {
    mode: VueTypes.any,
    value: VueTypes.any,
    isInline: VueTypes.bool,
    onChange: VueTypes.any
  },

  methods: {
    getDateElements(date = new Date()) {
      const today = new Date(date);
      return {
        year: today.getFullYear(),
        month: today.getMonth() + 1,
        day: today.getDate()
      };
    }
  },

  computed: {
    fromPage() {
      return this.getDateElements(this.value.start);
    },

    toPage() {
      this.getDateElements(this.value.end);
    }
  }
});
</script>

<style lang="scss">
.c-day-slide-left-scale-enter,
.c-day-box-center-center,
.c-day-slide-right-scale-enter {
  .c-day-background {
    width: 38px !important;
    height: 38px !important;
  }

  .c-day-background {
    border-radius: 3px !important;
    background: $primary-color !important;
  }
}

.c-day-box-center-center {
  .c-day-background {
    background: #8484f9 !important;
  }
}

.c-day-backgrounds {
  overflow: visible !important;
}

.c-day-content {
  min-width: 38px !important;
  background-color: transparent !important;
}

.c-weekdays {
  margin-top: 20px !important;
  margin-bottom: 15px !important;

  .c-weekday {
    color: #979797 !important;
    font-family: Lato-Regular, sans-serif !important;
  }
}

.c-weeks {
  padding: 0 10px 10px !important;
}

.shift-left {
  margin-right: -1px !important;
  margin-left: 0 !important;
}

.popover-content-wrapper {
  .c-table {
    td {
      border-color: #c5c5c5 !important;
    }

    .c-table-cell {
      font-size: 12px;
      font-family: "Lato-Regular", sans-serif;

      &.c-active {
        background: $primary-color !important;
        color: $white;
      }
    }
  }
}

.c-arrow-layout {
  svg:hover {
    color: $primary-color !important;
    fill-opacity: 1 !important;
  }
}
</style>
